import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Select from "react-select";
import { useFormik } from "formik";
import RichTextEditor from "../../../Components/Editor/RichTextEditor";
import uploadImageApi from "../../../utilis/uploadImage";
import { useNavigate, useParams } from "react-router-dom";
import EmailTemplateService from "../../../services/KangarooServices/EmailTemplateService";
import toast from "react-hot-toast";

const EmailForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState({});

  const breadcrumbItems = [{ title: "Back to List", link: "/email-templates" }];
  const templateType = {
    OTPVerification: 0,

    Welcome: 1,

    PasswordReset: 2,
  };
  const typeOptions = Object.entries(templateType).map(([label, value]) => ({
    label,
    value,
  }));
  const fetchDetail = async () => {
    try {
      const response = await EmailTemplateService.getbyId(id);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (id) fetchDetail();
  }, [id]);
  const formik = useFormik({
    initialValues: {
      templateType: detailData?.templateType || 0,
      subject: detailData?.subject || "",
      body: detailData?.body || "",
      isActive: detailData?.isActive || true,
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      try {
        let response;
        if (id) {
          await EmailTemplateService.update(id, values);
          toast.success(response || "Template updated succesfull.");
        } else {
          await EmailTemplateService.create(values);
          toast.success(response || "New template created succesfull.");
        }
        navigate("/email-templates");
      } catch (error) {
        console.log(error);
      }
    },
  });
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Email Template Form"
          pageTitle="Email Template"
          breadcrumbItems={breadcrumbItems}
        />

        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-3 mb-3">
            <button type="submit" className="btn btn-success">
              {id ? "Update" : "Create"}
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => navigate("/email-templates")}
            >
              Cancel
            </button>
          </div>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <div className="mb-3">
                    <Label>Email Template Type</Label>
                    <Select
                      options={typeOptions}
                      name="templateType"
                      value={
                        typeOptions.find(
                          (option) =>
                            option.value === formik.values.templateType,
                        ) || null
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          "templateType",
                          selectedOption ? selectedOption.value : "",
                        )
                      }
                      placeholder="Select email template Type"
                      isDisabled={id}
                    />
                  </div>
                </Col>
                <Col>
                  <FormGroup className="d-flex justify-content-between">
                    <Label>Is Active?</Label>
                    <Input
                      type="checkbox"
                      checked={formik.values.isActive}
                      onChange={(e) =>
                        formik.setFieldValue("isActive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormGroup className="mb-3">
                <Label htmlFor="subtitle">Subject</Label>
                <Input
                  id="subject"
                  name="subject"
                  type="textarea"
                  value={formik.values.subject}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.subject && !!formik.errors.subject}
                  rows={2}
                />
                {formik.touched.subject && formik.errors.subject && (
                  <FormFeedback>{formik.errors.subject}</FormFeedback>
                )}
              </FormGroup>
              <div className="snow-editor" style={{ height: 400 }}>
                <Label>
                  Body <span className="text-danger">*</span>
                </Label>

                <RichTextEditor
                  formik={formik}
                  fieldName="body"
                  uploadImageApi={uploadImageApi}
                />
              </div>
            </CardBody>
          </Card>
        </form>
      </div>
    </Container>
  );
};

export default EmailForm;
